import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "default-modify" }
const _hoisted_2 = { class: "default-modify_top flex-row justify-between align-center" }
const _hoisted_3 = { class: "default-modify_progress flex-row" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "current-progress" }
const _hoisted_9 = { class: "current-progress_bg" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "current-progress_position" }
const _hoisted_15 = { class: "current-progress_position-address" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "current-title flex-row" }
const _hoisted_19 = { class: "transition-out" }
const _hoisted_20 = {
  key: 1,
  class: "current-title_text"
}
const _hoisted_21 = { class: "transition-out" }
const _hoisted_22 = { class: "progress-bar-container" }
const _hoisted_23 = { class: "progress-bar-container__label" }

import { modalController } from "@ionic/vue";
import { onBeforeUnmount, ref, watch } from "vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useExerciseCountdownStore } from "@/hooks/useExerciseCountdown";
import { useCurrentStepStore } from "@/hooks/useCurrentStepStore";
import { useRoute } from "vue-router";
import { useStorage, useThrottleFn } from "@vueuse/core";
import PageDialog from "@/components/PageDialog.vue";
import { getBrandImageUrl } from "@/js/brandImages";
import { default_step_title } from "@/views/AIGenerate/smartReading/defaultData";
import ArticleEndModal from "@/views/reading/newReadingArticle/ArticleEndModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleProgress',
  props: ["modalIsFold", "exerciseObj", "btnDisabled", "readingId", "wordCount","fromAdmin"],
  emits: [
  "getCurrentStep",
  "closeCurrentHalfModal",
  "clickProgressTitle",
  "openCurrentHalfPage",
  "hideAllAudioIcon",
  "pauseAudioPlayer",
],
  setup(__props, { emit: __emit }) {

/* eslint-disable */

const props = __props;
const emit = __emit
const countdownStore = useExerciseCountdownStore()
const currentStepStore = useCurrentStepStore()
const route = useRoute()
const aiTheme = useStorage("ai-theme", "brown", localStorage)
const aiReadingTime = useStorage("aiReadingTime", 0, sessionStorage)
const aiReadingStatus = useStorage("aiReadingStatus", "", sessionStorage)
const studentInfo = ref()
const step_ready_status = ref(default_step_title.map(() => true))
const throttledStep = useThrottleFn(() => {
  if (props.btnDisabled) return
  clickNextProgressStep()
}, 500)
const btnDisabled = ref(true)
watch(
  () => props.wordCount,
  () => {
    if (!aiReadingStatus.value) {
      aiReadingTime.value = 180
      startTime()
    } else if (aiReadingStatus.value === "start") {
      startTime()
    }
  },
  { deep: true }
)

function startTime() {
  aiReadingStatus.value = "start"
  const timer = setInterval(() => {
    if (aiReadingTime.value === 0) {
      clearInterval(timer)
    } else {
      aiReadingTime.value = aiReadingTime.value - 1
    }
  }, 1000)
}

function finishReading() {
  if (props.btnDisabled) return
  aiReadingStatus.value = "end"
  clickNextProgressStep()
}

function clickTitleEvent() {
  emit("clickProgressTitle")
}

function alertModal() {
  return new Promise(async (resolve) => {
    const modal = await modalController.create({
      id: "PageDialog",
      component: PageDialog,
      componentProps: {
        title: "提示信息",
        message: "是否回退？",
        type: "hasCancel",
      },
      cssClass: "center_modal_controller_class3",
    })

    modal.onDidDismiss().then((res) => {
      if (res.data === "NEXT") {
        resolve("ENSURE")
      } else {
        resolve("CANCEL")
      }
    })
    return modal.present()
  })
}

// 上一步
function goBackLastStep() {
  if (props.btnDisabled) return
  if (currentStepStore.currentStep === 1) {
    return
  }

  alertModal().then((data) => {
    if (data === "ENSURE") {
      if (currentStepStore.currentStep === 4 || currentStepStore.currentStep === 5) {
        clearSentenceStyle()
        emit("pauseAudioPlayer")
      }
      currentStepStore.goBackLastStep(closeCurrentHalfModal, openCurrentHalfPage)
    }
  })
}

function createSentenceNode(cn: string) {
  const cnDom = document.createElement("span")
  cnDom.className = "ai-sentence-paraphrase"
  cnDom.style.display = "none"
  cnDom.style.color = "#97989C"
  // const cn = translateArr[idx]?.sentenceWithParaphraseCn || ''
  cnDom.innerHTML = cn.replaceAll("**", "")
  return cnDom
}

function clearSentenceStyle() {
  if (currentStepStore.currentStep === 4) {
    const article = document.querySelectorAll(".ai-article-sentence")
    if (article) {
      article.forEach((el: any) => {
        el.style.backgroundColor = "transparent"
        el.style.color = "#606266"
      })
    }
    const paragraphArr = document.querySelectorAll(".ai-sentence-paraphrase")
    const analysisIcon = document.querySelectorAll(".analysis-icon")

    if (paragraphArr) {
      paragraphArr.forEach((el: any) => {
        // el.classList.add('sentence-paraphrase-hidden')
        el.style.display = "none"
      })
    }
    if (analysisIcon) {
      analysisIcon.forEach((el: any) => {
        el.classList.add("sentence-paraphrase-hidden")
      })
    }
  }
  if (currentStepStore.currentStep === 5) {
    hiddenAllParagraphStyle()
  }
  emit("hideAllAudioIcon")
}

function hiddenAllParagraphStyle() {
  const paragraphDomArr = document.querySelectorAll(".ai-article-paragraph")
  if (paragraphDomArr) {
    paragraphDomArr.forEach((el: any) => {
      el.classList.remove("ai-article-highlight")
      const audioIconDom = el.querySelector("#ai-sentence-audio")
      const essayIconDom = el.querySelector(".essay-icon")
      audioIconDom.classList.add("sentence-paraphrase-hidden")
      essayIconDom.classList.add("sentence-paraphrase-hidden")
    })
  }
}

let timer: any = null
let flag

async function clickNextProgressStep() {
  const exeObj = props.exerciseObj
  //如果5道题全部有答案，则继续下一步
  if (!countdownStore.countdownEnds) {
    if (2 === currentStepStore.currentStep && !exeObj.answer) {
      await openMsgToast("你还未提交测试答案")
      return
    }
  }

  if (currentStepStore.currentStep === 4 || currentStepStore.currentStep === 5) {
    clearSentenceStyle()
  }
  emit("pauseAudioPlayer")
  // 根据相关流程的内容是否生成完毕，放开该流程的使用功能
  await handleProgressEvent()
  // await openStartExerciseModal() // 开始测试
}

// 操作下一步 | 上一步内容
async function handleProgressEvent() {
  currentStepStore.controlStepData() // 处理流程执行数据
  currentStepStore.handleProgressTitleNameArr() // 动态展示流程名称
  await currentStepStore.handleProgressStepEvent(closeCurrentHalfModal, openCurrentHalfPage) // 处理每个流程相关的事件

  if (currentStepStore.processIsEnd && !props.fromAdmin) {
    await currentStepStore.handleEndOfProcessEvent(openEndNotifyModal, closeCurrentHalfModal) // 流程结束
  }
}

function closeCurrentHalfModal() {
  emit("closeCurrentHalfModal")
}

async function openCurrentHalfPage() {
  // 2-泛读答题 & 6-全文大意 & 9-知识点
  if ([2, 6, 9].includes(currentStepStore.currentStep)) {
    const exeObj = props.exerciseObj
    switch (currentStepStore.currentStep) {
      case 2: // 泛读答题
        emit("openCurrentHalfPage")
        break
      case 6: // 全文大意
        emit("openCurrentHalfPage")
        break
      case 9: // 知识点
        emit("openCurrentHalfPage")
        break
      default:
        break
    }
    return
  }
  emit("openCurrentHalfPage")
}

// 已完成流程最后一步环节，结算弹窗
async function openEndNotifyModal() {
  if (currentStepStore.processIsEnd) {
    const modal = await modalController.create({
      component: ArticleEndModal,
      componentProps: { readingId: props.readingId, fromPrepareOrigin: props.fromPrepareOrigin },
      showBackdrop: false,
      cssClass: "center_modal_controller_class",
    })
    await modal.present()
    modal.onDidDismiss().then(({ data }) => {
      if (data.type === "TEXT") {
        modalController.dismiss("FINISHED").catch((e) => console.log(e))
      }
    })
  }
}

onBeforeUnmount(() => {})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("i", {
        class: "operate-text iconfont icon-shangyibu cursor-pointer button-ripple",
        style: _normalizeStyle(props.btnDisabled ? 'background:#e5d6be!important' : ''),
        onClick: goBackLastStep
      }, null, 4),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("img", {
          class: "default-modify_progress-bg",
          src: _unref(getBrandImageUrl)('ai_smart_reading/next_step_bg.png'),
          alt: ""
        }, null, 8, _hoisted_4), [
          [_vShow, _unref(aiTheme) === 'default']
        ]),
        _withDirectives(_createElementVNode("img", {
          class: "default-modify_progress-bg",
          src: _unref(getBrandImageUrl)('ai_smart_reading/next_step_bg_brown.png'),
          alt: ""
        }, null, 8, _hoisted_5), [
          [_vShow, _unref(aiTheme) === 'brown']
        ]),
        _withDirectives(_createElementVNode("img", {
          class: "default-modify_progress-bg",
          src: _unref(getBrandImageUrl)('ai_smart_reading/next_step_bg_silver.png'),
          alt: ""
        }, null, 8, _hoisted_6), [
          [_vShow, _unref(aiTheme) === 'silver']
        ]),
        _withDirectives(_createElementVNode("img", {
          class: "default-modify_progress-bg",
          src: _unref(getBrandImageUrl)('ai_smart_reading/next_step_bg_dark.png'),
          alt: ""
        }, null, 8, _hoisted_7), [
          [_vShow, _unref(aiTheme) === 'dark']
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("img", {
              class: "current-progress_progress",
              src: _unref(getBrandImageUrl)('ai_smart_reading/progress_bg.png'),
              alt: ""
            }, null, 8, _hoisted_10), [
              [_vShow, _unref(aiTheme) === 'default']
            ]),
            _withDirectives(_createElementVNode("img", {
              class: "current-progress_progress",
              src: _unref(getBrandImageUrl)('ai_smart_reading/progress_bg_brown.png'),
              alt: ""
            }, null, 8, _hoisted_11), [
              [_vShow, _unref(aiTheme) === 'brown']
            ]),
            _withDirectives(_createElementVNode("img", {
              class: "current-progress_progress",
              src: _unref(getBrandImageUrl)('ai_smart_reading/progress_bg_silver.png'),
              alt: ""
            }, null, 8, _hoisted_12), [
              [_vShow, _unref(aiTheme) === 'silver']
            ]),
            _withDirectives(_createElementVNode("img", {
              class: "current-progress_progress",
              src: _unref(getBrandImageUrl)('ai_smart_reading/progress_bg_dark.png'),
              alt: ""
            }, null, 8, _hoisted_13), [
              [_vShow, _unref(aiTheme) === 'dark']
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("img", {
                  class: _normalizeClass(["current-progress_position-step transition-out step_1_width", {
                    step_1_width: [1].includes(_unref(currentStepStore).currentStep),
                    step_2_width: [2,5, 8].includes(_unref(currentStepStore).currentStep),
                    step_3_width: [3,6, 9].includes(_unref(currentStepStore).currentStep),
                    step_4_width: [4, 7,10].includes(_unref(currentStepStore).currentStep),
                  }]),
                  src: _unref(getBrandImageUrl)('ai_smart_reading/progress_passed_step_2.png'),
                  alt: ""
                }, null, 10, _hoisted_16),
                _createElementVNode("img", {
                  class: _normalizeClass(["current-progress_position-pencil transition-out pencil-left-step-1", {
                    'pencil-left-step-1': [1].includes(_unref(currentStepStore).currentStep),
                    'pencil-left-step-2': [2,5, 8].includes(_unref(currentStepStore).currentStep),
                    'pencil-left-step-3': [3,6, 9].includes(_unref(currentStepStore).currentStep),
                    'pencil-left-step-4': [4,7, 10].includes(_unref(currentStepStore).currentStep),
                  }]),
                  src: _unref(getBrandImageUrl)('ai_smart_reading/progress_pencil.png'),
                  alt: ""
                }, null, 10, _hoisted_17)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            class: _normalizeClass(["current-title_bg", {
              'bg_color_step_1 transition-out': [1].includes(_unref(currentStepStore).currentStep),
              'bg_color_step_2 transition-out': [2,5, 8].includes(_unref(currentStepStore).currentStep),
              'bg_color_step_3 transition-out': [3,6, 9].includes(_unref(currentStepStore).currentStep),
              'bg_color_step_4 transition-out': [4,7, 10].includes(_unref(currentStepStore).currentStep),
            }])
          }, null, 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentStepStore)?.currentStepList, (step) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step.step,
              class: _normalizeClass(["current-title_name justify-center", {
              'current-text': _unref(currentStepStore).currentStep === step.step,
              'is-ready-class': step_ready_status.value[step.step - 1],
            }])
            }, [
              ([2, 3, 5, 6, 7, 8, 9].includes(_unref(currentStepStore)?.currentStep))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "current-title_text cursor-pointer",
                    onClick: clickTitleEvent
                  }, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(step.title), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(step.title), 1)
                  ]))
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("i", {
        class: "operate-text iconfont icon-xiayibu cursor-pointer button-ripple",
        style: _normalizeStyle(props.btnDisabled ? 'background:#e5d6be!important' : ''),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(throttledStep) && _unref(throttledStep)(...args)))
      }, null, 4)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, "正在泛读整篇文章，" + _toDisplayString(_unref(aiReadingTime)) + "s", 1),
      _createElementVNode("div", {
        class: "progress-bar-container__btn button-ripple",
        onClick: finishReading
      }, "我读完了")
    ], 512), [
      [_vShow, _unref(currentStepStore)?.currentStep === 1 && _unref(aiReadingStatus) !== 'end']
    ])
  ]))
}
}

})